<template>
    <div>
        <div>
            <div class="main-wrapper">
                <div>
                    <!-- <layout-header2></layout-header2> -->
                    <layout-header></layout-header>
                    <breadcrumb57></breadcrumb57>
                    <!-- Page Content -->
                    <div class="content">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                    <sidebar></sidebar>
                                </div>

                                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                                    <loader></loader>
                                </div>

                                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                                    <!-- Basic Information -->
                                    <i class="fa fa-arrow-left fa-lg ml-md-4" aria-hidden="true"
                                        style="background-color:black; color:white;padding:10px;border-radius:100%; cursor: pointer;"
                                        @click="goBack"></i>
                                    <div class="card mt-2 ml-md-4">
                                        <div class="card-body">
                                            <h3 class="mt-3">Diagnosis</h3>
                                            <div class="row mt-2">
                                                <div class="form-group col-md-6 col-sm-12 mt-2">
                                                    <label>Name of Diagnosis</label>
                                                    <input v-model="new_diagnosis" type="text" class="form-control" value=""
                                                        oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                                                    <div class="mt-4">
                                                        <button data-dismiss="modal" aria-label="Close"
                                                            class="btn btn-primary submit-btn" @click="
                                                                // $bvModal.hide('Add_Diagnosis_modal');
                                                                add_diagnosis();
                                                            ">
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /Basic Information -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Page Content -->
                    <layout-footer></layout-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
export default {
    data() {
        return {
            showspinner: false,
            new_diagnosis: "",
        };
    },
    computed: {
        ...mapState({
            user_id: (state) => state.user.user_id,
        }),
    },
    methods: {

        async add_diagnosis() {
            this.$swal({
                text: "Adding Diagnosis...",
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            let data = {
                diagnosis: this.new_diagnosis,
                practitioner: this.user_id,
            };
            await CommonApi.post_data("sahaj.api.add_diagnosis_dr", data).then(
                (res) => {
                    this.showspinner = false;
                    if (res && res.status_code === 200) {
                        this.$swal.fire({
                            icon: "success",
                            title: "Success",
                            text: res.message,
                            showConfirmButton: true,
                        }).then(() => {
                            this.$router.push(`/doctor/treatment-plan`);
                            this.diagnosis.push({ diagnosis: this.new_diagnosis });
                        });
                        this.$emit("close");
                    } else {
                        this.$swal.fire({
                            icon: "warning",
                            title: "Warning",
                            text: res.message,
                            showConfirmButton: true,
                        });
                    }
                    this.new_diagnosis = "";
                }
            );
        },

        close() {
            window.location.reload();
        },
        goBack() {
            // Go one page back
            this.$router.go(-1);
        },

        /* Get All Excercise Plane Details */
        formatDescription(description) {
            return description.replace(/\n/g, '<br>');
        },

    },
    mounted() {
        let user = localStorage.getItem("userInfo");
        if (!user) {
            this.$router.push({ name: 'login' })
        }
    },
};
</script>

<style scoped>
/* Default column widths */
.column-name {
    min-width: 400px;
}

.column-description {
    min-width: 520px;
}

.column-action {
    min-width: 90px;
}

/* Responsive column widths for smaller screens */
@media (max-width: 768px) {
    .column-name {
        min-width: 250px;
    }

    .column-description {
        min-width: 400px;
    }

    .column-action {
        min-width: 70px;
    }
}

/* Responsive column widths for even smaller screens */
@media (max-width: 480px) {
    .column-name {
        min-width: 150px;
    }

    .column-description {
        min-width: 250px;
    }

    .column-action {
        min-width: 60px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/addDiagnosis.vue